import React, { FC } from 'react';
import { JobTitleDetailForm } from './job-title-detail-form';

interface IJobTitleDetails {}

export const JobTitleDetails: FC<IJobTitleDetails> = () => {
  return <JobTitleDetailForm />;
};
